<template>
  <b-row>
    <b-col>
      <search-properties
        :form="form.property"
        ref="searchProp"
        button-variant="success"
      />
    </b-col>
  </b-row>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import searchProperties from '@/components/utils/properties/SearchProperties';
import schemaDefinition from './schema';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    'search-properties': searchProperties,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      schema: schemaDefinition.schema,
      formOptions: schemaDefinition.formOptions,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/new_deal/components/property/crosses/CrossesSection.vue